import Vue from "vue";
import { Route, RawLocation } from "vue-router";
import { DomainRegistry } from "../domain";
import { Dispatcher as BaseDispatcher } from "../../base/routing";
import { Query } from "./Query";

export class Dispatcher<TQuery extends Query> extends BaseDispatcher<TQuery> {
  constructor(toQuery: (r: Route) => TQuery) {
    super(toQuery);
  }

  public async dispatchOnEditFormat<V extends Vue = Vue>(to: Route, next: (to?: RawLocation | false | ((vm: V) => any) | void) => void): Promise<void> {
    this.dispatch(to, next, async q => {
      if (!(await DomainRegistry.instance.editableFormat.getFormatRepository().getEditable(q.formatId))) {
        return this.toError(to, "編集権限がありません。");
      }
    });
  }

  public async dispatchOnAccessFormat<V extends Vue = Vue>(to: Route, next: (to?: RawLocation | false | ((vm: V) => any) | void) => void): Promise<void> {
    this.dispatch(to, next, async q => {
      // 新規作成時はformatIdがないため、数値であることを確認してからアクセス権の確認を行う
      if (!isNaN(q.formatId) && !(await DomainRegistry.instance.editableFormat.getFormatRepository().getAccessible(q.formatId))) {
        return this.toError(to, "参照権限がありません。");
      }
    });
  }
}
